// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1EPVo","image":"Header_image__3qam2","name":"Header_name__3FEW7","info":"Header_info__1RrTW","infoRow":"Header_infoRow__1lwdF"};